import { api } from './api';

// Buffer for batching events
let eventBuffer = [];
let flushTimer = null;

const BATCH_SIZE = 10;
const BATCH_DELAY_MS = 2000;

export function sendPlaylistEvent(playlistId, eventType, meta = {}) {
  const event = {
    playlist_id: playlistId,
    event_type: eventType,
    ...meta,
    ts: new Date().toISOString()
  };

  eventBuffer.push(event);

  // Auto-flush if buffer is full
  if (eventBuffer.length >= BATCH_SIZE) {
    flushEvents();
  } else {
    // Schedule flush
    if (flushTimer) clearTimeout(flushTimer);
    flushTimer = setTimeout(flushEvents, BATCH_DELAY_MS);
  }
}

async function flushEvents() {
  if (eventBuffer.length === 0) return;

  const eventsToSend = [...eventBuffer];
  eventBuffer = [];

  if (flushTimer) {
    clearTimeout(flushTimer);
    flushTimer = null;
  }

  try {
    await api.post('/playlist-events', { events: eventsToSend });
  } catch (error) {
    console.error('Failed to send playlist events:', error);
  }
}

// Flush on page unload
if (typeof window !== 'undefined') {
  window.addEventListener('beforeunload', () => {
    if (eventBuffer.length > 0) {
      // Use sendBeacon for reliable delivery on page unload
      const data = JSON.stringify({ events: eventBuffer });
      navigator.sendBeacon(
        `${process.env.REACT_APP_BACKEND_URL}/api/playlist-events`,
        data
      );
      eventBuffer = [];
    }
  });
}
